import { Dialog } from "@chakra-ui/react";

const CustomDialogBackdrop = () => (
  <Dialog.Backdrop
    backdropFilter="blur(3px)"
    _open={{
      animation: "fade-in 0.25s ease-out"
    }}
    _closed={{
      animation: "fade-out 0.25s ease-in"
    }}
  />
);

export default CustomDialogBackdrop;
